import deliveryNotesSaga from './handleDeliveryNotes';

export default deliveryNotesSaga;
